var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { INPUT } from "../../../classConstants";
import styled from 'styled-components';
import { getClassName } from '../../../helpers';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "./css.css";
var StyledTimePicker = styled(DatePicker)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n"], ["\n"])));
var timePickerFactory = function () {
    var TimePicker = function (_a) {
        var _b;
        var value = _a.value, placeholder = _a.placeholder, props = __rest(_a, ["value", "placeholder"]);
        return React.createElement(StyledTimePicker, __assign({}, props, {
            selected: value && ((_b = new Date(value)) === null || _b === void 0 ? void 0 : _b.getTime()) ? new Date(value) : null,
            className: getClassName("ws-time", INPUT),
            showPopperArrow: false,
            showTimeSelect: true,
            timeCaption: "Time",
            shouldCloseOnSelect: true,
            placeholderText: placeholder
        }));
    };
    return TimePicker;
};
export var TimeField = timePickerFactory();
var templateObject_1;
